// extracted by mini-css-extract-plugin
export default {"link":"MatchLink-module--link--D7jF2"};